import React from 'react'
import { CheckCircle, XCircle, Question } from '@phosphor-icons/react'

interface DnsStatusBadgeProps {
  spf?: boolean | null
  dkim?: boolean | null
  dmarc?: boolean | null
}

const PILL = 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full border uppercase tracking-[0.06em]'
const pillStyle = { fontSize: '10px', fontWeight: 590 } as const

const Badge: React.FC<{ label: string; valid?: boolean | null }> = ({ label, valid }) => {
  if (valid === true) {
    return (
      <span
        className={`${PILL} bg-emerald-500/10 border-emerald-500/25 text-emerald-700 dark:bg-emerald-500/[0.12] dark:border-emerald-500/30 dark:text-emerald-300`}
        style={pillStyle}
      >
        <CheckCircle className="w-3 h-3" weight="fill" />
        {label}
      </span>
    )
  }
  if (valid === false) {
    return (
      <span
        className={`${PILL} bg-red-500/10 border-red-500/25 text-red-700 dark:bg-red-500/[0.12] dark:border-red-500/30 dark:text-red-300`}
        style={pillStyle}
      >
        <XCircle className="w-3 h-3" weight="fill" />
        {label}
      </span>
    )
  }
  return (
    <span
      className={`${PILL} bg-muted/60 border-border/50 text-muted-foreground dark:bg-white/[0.04] dark:border-white/[0.06] dark:text-[#8a8f98]`}
      style={pillStyle}
    >
      <Question className="w-3 h-3" />
      {label}
    </span>
  )
}

const DnsStatusBadge: React.FC<DnsStatusBadgeProps> = ({ spf, dkim, dmarc }) => {
  return (
    <div className="flex items-center gap-2">
      <Badge label="SPF" valid={spf} />
      <Badge label="DKIM" valid={dkim} />
      <Badge label="DMARC" valid={dmarc} />
    </div>
  )
}

export default DnsStatusBadge
